<template>
	<div>
		<ChenLieNav @changeTab="changeTab"></ChenLieNav>
		<div class="jbcl-block" v-if="chenLieType === 'jbcl'">
			<div class="jbcl-box" v-for="(item, index) in dataList" :key="index" @mouseover="moveIn(index)" @mouseleave="moveOut(index)" @click="toDetails(item.id)">
				<img :src="$imgUrl + item.listImgPc" alt="">
				<div class="jbcl-title">
					{{item.title}}
				</div>
				<transition name="fold">
					<div class="jbcl-details" v-show="moveIndex === index">
						<div class="title">
							{{item.title}}
						</div>
						<div class="content">
							{{item.shortTitle}}
						</div>
					</div>
				</transition>
			</div>
		</div>
		<div class="jbcl-block" v-if="chenLieType === 'lhyzq'">
			<div class="jbcl-box" v-for="(item, index) in dataList" :key="index" @mouseover="moveIn(index)" @mouseleave="moveOut(index)" @click="toDetails(item.id)">
				<img :src="$imgUrl + item.listImgPc" alt="">
				<div class="jbcl-title">
					{{item.title}}
				</div>
				<transition name="fold">
					<div class="jbcl-details" v-show="moveIndex === index">
						<div class="title">
							{{item.title}}
						</div>
						<div class="content">
							{{item.shortTitle}}
						</div>
					</div>
				</transition>
			</div>
		</div>
		<div class="jbcl-block" v-if="chenLieType === 'ztzl'">
			<div class="jbcl-box" v-for="(item, index) in dataList" :key="index" @mouseover="moveIn(index)" @mouseleave="moveOut(index)" @click="toDetails(item.id)">
				<img :src="$imgUrl + item.listImgPc" alt="">
				<div class="jbcl-title">
					{{item.title}}
				</div>
				<transition name="fold">
					<div class="jbcl-details" v-show="moveIndex === index">
						<div class="title">
							{{item.title}}
						</div>
						<div class="content">
							{{item.shortTitle}}
						</div>
					</div>
				</transition>
			</div>
		</div>
		<!-- <div class="ztzl-block" v-if="chenLieType === 'ztzl'">
			<div class="ztzl-box" v-for="(item, index) in dataList" :key="index" @click="toZtzlDetails(item.id)">
				<div class="ztzl-img">
					<img :src="$imgUrl + item.listImgPc" alt="">
				</div>
				<div class="ztzl-bottom">
					<div class="ztzl-left">
						<div class="title">
							{{item.title}}
						</div>
						<div class="content">
							{{item.shortTitle}}
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<div class="ywzl-block" v-if="chenLieType === 'ywzl'">
			<div class="ywzl-box" v-for="(item, index) in dataList" :key="index" @click="toYwzlDetails(item.id)">
				<div class="ywzl-img">
					<img :src="$imgUrl + item.listImgPc" alt="">
				</div>
				<div class="ywzl-bottom">
					<div class="title">
						<div class="title-left">
							{{item.title}}
						</div>
						<div class="title-right">
							<span title="视频讲解" v-if="item.video" @click.stop="toVideo(item.video)">
								<i class="iconfont icondianyingshipin" style="color: #264EA7;"></i>
							</span>
							<!-- <span title="网上展厅">
								<i class="iconfont iconshexiangtou" style="color: #264EA7;"></i>
							</span>
							<span title="解说词">
								<i class="iconfont iconkefu" style="color: #264EA7;"></i>
							</span> -->

						</div>
					</div>
					<div class="content">
						{{item.shortTitle}}
					</div>
				</div>
			</div>
		</div>
		<page :pageObj="params" :startSearch="false" style="margin-bottom: 80px;" @getDataList="getData" ref="page"></page>
	</div>
</template>

<script>
	import ChenLieNav from '@/components/ChenLieNav.vue'
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			ChenLieNav,
			Page
		},
		data () {
			return {
				moveIndex: "",
				dataList: [],
				params: {
					current: 1,
					size: 6,
					channelId: "",
					releaseTerrace: "releasePc"
				}
			}
		},
		computed: {
			chenLieType() {
				return this.$store.state.chenLieType
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
			that.getNewData()
		},
		methods: {
			getNewData() {
				this.$store.state.secondList[0].children.some(item => {
					if(item.path === this.chenLieType) {
						this.$store.state.channelId = item.id
						this.changeTab()
					}
				})
			},
			changeTab() {
				console.log(1);
				this.params.current = 1
				this.params.channelId = this.$store.state.channelId
				this.dataList = []
				this.$refs.page.getData()
			},
			getData(dataList) {
				this.dataList = dataList
				this.$forceUpdate()
			},
			moveIn(index) {
				this.moveIndex = index
			},
			moveOut() {
				this.moveIndex = ""
			},
			toDetails(zlg_id) {
				this.$router.push({
					path: '/jbzl_details',
					query: {
						zlg_id: zlg_id
					}
				})
			},
			toZtzlDetails(zt_id) {
				this.$router.push({
					path: '/ztzl_details',
					query: {
						zt_id: zt_id
					}
				})
			},
			toYwzlDetails(ywzl_id) {
				this.$router.push({
					path: '/ywzl_details',
					query: {
						ywzl_id: ywzl_id
					}
				})
			},
			toVideo(video_id) {
				this.$router.push({
					path: '/video_player',
					query: {
						video_id: video_id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>

	.jbcl-block {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1100px;
		margin: 0 auto 90px;
		.jbcl-box {
			width: 48%;
			position: relative;
			margin-top: 25px;
			cursor: pointer;
			overflow: hidden;
			img {
				height: 100%;
				width: 100%;
			}
			.jbcl-title {
				position: absolute;
				top: 28px;
				left: 5%;
				width: 90%;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 24px;
				color: #FFFFFF;
				text-align: left;
			}
			.fold-enter-active {
			  animation-name: fold-in;
			  animation-duration: 1s;
			}
			.fold-leave-active {
			  animation-name: fold-out;
			  animation-duration: 1s;
			}
			@keyframes fold-in {
			  0% {
			    transform: translate3d(0, 100%, 0);
			  }
			  // 50% {
			  //   transform: translate3d(0, 50%, 0);
			  // }
			  100% {
			    transform: translate3d(0, 0, 0);
			  }
			}
			@keyframes fold-out {
			  0% {
			    transform: translate3d(0, 0, 0);
			  }
			  // 50% {
			  //   transform: translate3d(0, 50%, 0);
			  // }
			  100% {
			    transform: translate3d(0, 100%, 0);
			  }
			}
			.jbcl-details {
				position: absolute;
				width: 100%;
				left: 0;
				padding: 20px;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.5);
				color: #FFFFFF;
				bottom: 0;
				overflow: hidden;
				.title {
					text-align: left;
					color: #FFFFFF;
					font-size: 20px;
					height: 37px;
					margin-top: 80px;
				}
				.content {
					color: #FFFFFF;
					text-align: left;
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}

		}
		// .jbcl-box:hover {
		// 	.jbcl-details {
		// 		position: absolute;
		// 		width: 100%;
		// 		padding: 20px;
		// 		left: 0;
		// 		background-color: rgba(0, 0, 0, 0.5);
		// 		color: #FFFFFF;
		// 		bottom: 0;
		// 		max-height: 110px;
		// 		.title {
		// 			text-align: left;
		// 			color: #FFFFFF;
		// 			font-size: 20px;
		// 			height: 37px;
		// 		}
		// 		.content {
		// 			color: #FFFFFF;
		// 			text-align: left;
		// 			font-size: 14px;
		// 			overflow: hidden;
		// 			text-overflow: ellipsis;
		// 			display: -webkit-box;
		// 			-webkit-line-clamp: 2;
		// 			line-clamp: 2;
		// 			-webkit-box-orient: vertical;
		// 		}
		// 	}
		// }
	}
	.ztzl-block {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1100px;
		margin: 0 auto 90px;
		.ztzl-box {
			width: 48%;
			margin-top: 25px;
			display: flex;
			flex-direction: column;
			cursor: pointer;
			.ztzl-img {
				width: 100%;
				img {
					height: 100%;
					width: 100%;
				}
			}
			.ztzl-bottom {
				border: 3px solid #EDD68E;
				padding: 20px;
				width: 100%;
				height: 110px;
				background-color: #FFFFFF;
				display: flex;
				justify-content: space-between;
				.ztzl-left {
					width: 88%;
					.title {
						text-align: left;
						color: #264EA7;
						font-size: 13px;
						height: 26px;
					}
					.content {
						color: #686868;
						text-align: left;
						font-size: 9px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
					}
				}
				.ztzl-right {
					width: 5%;
					color: #333333;
					i {
						font-size: 13px;
					}
				}
			}
		}
	}
	.ywzl-block {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1100px;
		margin: 0 auto 90px;
		.ywzl-box {
			width: 48%;
			margin-top: 25px;
			display: flex;
			flex-direction: column;
			cursor: pointer;
			.ywzl-img {
				width: 100%;
				img {
					height: 100%;
					width: 100%;
				}
			}
			.ywzl-bottom {
				border: 3px solid #EDD68E;
				padding: 20px;
				width: 100%;
				height: 110px;
				background-color: #FFFFFF;
				.title {
					display: flex;
					justify-content: space-between;
					text-align: left;
					color: #264EA7;
					font-size: 13px;
					height: 26px;
					.title-left {
						width: 78%;
					}
					.title-right {
						width: 20%;
						text-align: right;
						color: #333333;
						i {
							margin-left: 5px;
						}
					}
				}
				.content {
					color: #686868;
					text-align: left;
					font-size: 9px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/visit_service/clzl.vue